import * as React from 'react';
import Form from './Form';
import List from './List';
// import { Link } from 'react-router-dom';
var scrollToElement = require('scroll-to-element');

class SearchView extends React.Component {

    public state: any;
    public constructor(props: any) {

        super(props);
        if (props.location.search) {

            const searchParams = props.location.search.substring(1, props.location.search.length);
            const searchParamsArray = searchParams.split('&');
            for (let i = 0; i < searchParamsArray.length; i++) {
                const splitArray = searchParamsArray[i].split('=');
                if (splitArray[0] === 'search') {
                    this.setFromGetParam('search', splitArray[1]);
                } else if (splitArray[0] === 'location') {
                    this.setFromGetParam('location', splitArray[1]);
                } else if (splitArray[0] === 'radius') {
                    this.setFromGetParam('radius', splitArray[1]);
                }
            }
        }

        this.state = { jobs: [], searchCount: 0, currentPage: 1, loading: false, search: '', location: '', radius: '' };
    }

    public componentDidMount() {

        const search = sessionStorage.getItem('search');
        const location = sessionStorage.getItem('location');
        const radius = sessionStorage.getItem('radius');

        if (search === null) { return; }

        this.request(search, location, 1, radius);
    }

    public request = async (search: string, location: string, pageToLoad: number = 1, radius: string) => {

        console.log('request', search, location, radius, pageToLoad);

        if (this.state.loading === true) { return; }
        if (search === '' && location === '') {
            return;
        }
        window.ga('send', 'event', 'search', 'submit', search, location);
        const searchCount = this.state.searchCount + 1;
        this.setState({ 
            loading: true, 
            searchCount: searchCount, 
            search: search, 
            location: location,
            radius: radius
        });
        let that = this;

        // https://www.stellenanbieter.de/api/?search=php&location=21244&page=1&radius=27

        let url = 'https://www.stellenanbieter.de/api/?search=' +
            search + '&location=' + location + '&page=' + pageToLoad;

        if (radius !== '0' && typeof radius !== undefined) {

            url += '&radius=' + radius;
        }
            
        console.log('SearchView request', url);
        let json;

        json = await fetch(url)
            .then(function (response: any) {

                return response.json();
            })
            .then(function (parsedData: any) {

                console.log('parsedData', parsedData);
                json = parsedData.data;
                let jobList = json.list;
                if (jobList.length > 0) {

                    jobList[0].label = 'page-' + pageToLoad;
                }

                if (pageToLoad > 1) {
                    jobList = [...that.state.jobs, ...jobList];
                }
 
                that.setState({
                    jobs: jobList,
                    pages: json.pages,
                    total: json.total,
                    perPage: json.perPage
                });
                sessionStorage.setItem(url, JSON.stringify(parsedData));
                that.setState({ loading: false});

                if (pageToLoad > 1) {

                    setTimeout(
                        () => { that.handleScrollToElement(pageToLoad); },
                        250
                    );
                }

                return json;
            });
        return json;
    }

    public render() {
        return (
            <div className="search-view-wrapper">

                <Form submitFunction={this.request} />
                {this.state.loading === true
                ? <div className="loading">Daten werden geladen</div>
                : this.state.jobs.length === 0 
                    ? this.state.searchCount === 0 
                        ? <div className="no-data">Bitte verwenden Sie unsere Suche</div>
                        : <div className="no-data">Ihre Suche ergab leider keine Treffer</div>
                    : <List data={this.state.jobs} /> 
                }

                {this.state.pages > 1 && this.state.currentPage < this.state.pages &&
                    <div className="load-more">
                        <button onClick={() => { this.loadMore(); }}>Weitere Stellenangebote Laden</button>
                    </div>
                }
            </div>
        );
    }

    private handleScrollToElement(pageNumber: number) {

        var elem = document.getElementById('page-' + pageNumber); 
        if (elem === null) { return; }
        
        scrollToElement(elem, {
            offset: 0,
            duration: 1500
        });
      }

    private loadMore() {
        const currentPageUp = this.state.currentPage + 1;
        this.setState({
            currentPage: currentPageUp
        });

        console.log('loadMore() ', currentPageUp, this.state);
        this.request(this.state.search, this.state.location, currentPageUp, this.state.radius);
    }

    private setFromGetParam(key: string, value: string) {

        sessionStorage.setItem(key, value);
        this.setState({
            key: value
        });
    }
}

export default SearchView;



// WEBPACK FOOTER //
// ./src/SearchView.tsx